import { render, staticRenderFns } from "./persona-aviso.vue?vue&type=template&id=a5277b98&scoped=true&"
import script from "./persona-aviso.vue?vue&type=script&lang=js&"
export * from "./persona-aviso.vue?vue&type=script&lang=js&"
import style0 from "./persona-aviso.vue?vue&type=style&index=0&id=a5277b98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5277b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5277b98')) {
      api.createRecord('a5277b98', component.options)
    } else {
      api.reload('a5277b98', component.options)
    }
    module.hot.accept("./persona-aviso.vue?vue&type=template&id=a5277b98&scoped=true&", function () {
      api.rerender('a5277b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/persona-aviso/persona-aviso.vue"
export default component.exports